/* ================================================================
   LWL — Sepet Adet Butonu Çift Tıklama Koruması
   ================================================================
   NEREYE EKLENİR:
     Bu dosyayı "assets" klasörüne yükleyin (adını değiştirmeyin:
     cart-quantity-guard.js), sonra layout/theme.liquid dosyasında
     </body> etiketinden hemen önce (cart-progress-bar.js'in
     yanına) şu satırı ekleyin:

       <script src="{{ 'cart-quantity-guard.js' | asset_url }}" defer></script>

   NEDEN GEREKLİ:
     Mobil cihazlarda +/- butonlarına hızlı art arda dokunulduğunda,
     temanın kendi (derlenmiş) sepet güncelleme script'i aynı anda
     iki /cart/change.js isteği gönderebiliyor. İlk istek sepeti
     günceleyip satırları yeniden oluşturunca, ikinci istek artık
     geçersiz bir satır referansı taşıyor ve "id veya satır
     parametresi yok" / "e.json is not a function" gibi hatalar
     ortaya çıkıyor.

     Bu script, temanın kendi tıklama mantığına DOKUNMADAN, bir
     butona dokunulduktan sonra kısa bir süre (600ms) aynı butona
     tekrar dokunulmasını engelliyor. Böylece çakışan istekler
     oluşmadan önce önleniyor.
   ================================================================ */
(function () {
	var LOCK_DURATION_MS = 600;

	function guardButton(btn) {
		if (btn.dataset.lwlGuarded === 'true') return;
		btn.dataset.lwlGuarded = 'true';

		// "capture: true" ile, bu dinleyici temanın kendi tıklama
		// işleyicisinden ÖNCE çalışır. Buton zaten kilitliyse tıklamayı
		// tamamen durdurur; değilse butonu kısa süreliğine kilitler ve
		// temanın kendi işleyicisinin normal şekilde çalışmasına izin verir.
		btn.addEventListener(
			'click',
			function (e) {
				if (btn.dataset.lwlLocked === 'true') {
					e.preventDefault();
					e.stopImmediatePropagation();
					return;
				}
				btn.dataset.lwlLocked = 'true';
				setTimeout(function () {
					btn.dataset.lwlLocked = 'false';
				}, LOCK_DURATION_MS);
			},
			true
		);
	}

	function guardAllButtons(root) {
		var buttons = root.querySelectorAll('[data-quantity-increase], [data-quantity-decrease]');
		Array.prototype.forEach.call(buttons, guardButton);
	}

	// İlk yükleme
	guardAllButtons(document);

	// Sepet çekmecesi/sayfası AJAX ile yeniden oluşturulduğunda, yeni
	// eklenen butonlara da aynı korumayı uygula.
	var observer = new MutationObserver(function (mutations) {
		for (var i = 0; i < mutations.length; i++) {
			if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
				guardAllButtons(document);
				break;
			}
		}
	});

	var target =
		document.querySelector('.js-cart-container') ||
		document.getElementById('CartDrawer') ||
		document.body;

	observer.observe(target, { childList: true, subtree: true });
})();
